import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/BreadCrumb";
import { Badge, DropdownAction } from "../../components/micro/input";
import { useLocation, useNavigate } from "react-router-dom";
import { Clock, DownArrow, Edit } from "../../assets/svg";
import Action from "../../components/common/Action";
import EditRemarkModal from "./EditRemarkModal";
import moment from "moment";
import {
  createRemark,
  createServiceByReport,
  getServiceById,
  sendAllServiceList,
} from "../../redux/service/slice";
import { useDispatch, useSelector } from "react-redux";
import RippleLoader from "../../components/RippleLoader/RippleLoader";
import ExistingQuotationModal from "./ExistingQuotationModal";

const ViewService = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isListVisible, setIsListVisible] = useState(true);
  const [isQuotationOpen, setIsQuotationOpen] = useState(true);
  const [isReceiptOpen, setIsReceiptOpen] = useState(true);
  const [isTimestampOpen, setIsTimestampOpen] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [remark, setRemark] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const serviceData = location?.state?.service;
  const [isExistingModalOpen, setIsExistingModalOpen] = useState(false);
  const [existingData, SetExistingData] = useState();

  // Selector
  const { getServiceListData, loading } = useSelector((store) => ({
    getServiceListData: store?.serviceData?.getServiceByIdStatus?.data?.data,
    loading: store?.serviceData?.loading,
  }));

  useEffect(() => {
    if (serviceData?.id) {
      dispatch(getServiceById(serviceData?.id));
    }
  }, [serviceData?.id]);

  const contractData = getServiceListData?.data?.[0];

  const handleAddButtonClick = (option, element) => {
    if (option.value === "duplicate" || option.value === "edit") {
      if (contractData?.service_request_type_id === 2) {
        navigate("/create-edit-recurring-service", {
          state: { service: serviceData, mode: option.value },
        });
      } else if (contractData?.service_request_type_id === 1) {
        navigate("/create-edit-service", {
          state: { service: serviceData, mode: option.value },
        });
      }
    } else if (option.value === "pushed_to_sale") {
      const payload = {
        ids: [element],
      };

      dispatch(sendAllServiceList(payload)).then((res) => {
        if (res.type === "sendAllServiceList/fulfilled") {
          dispatch(getServiceById(serviceData?.id));
        }
      });
    } else if (option.value === "push_to_quotation") {
      setIsExistingModalOpen(true);
      SetExistingData(element);
    }
  };

  const getDropdownOptions = (sale_status, title, sales_status) => {
    if (sale_status === "pushed to sale" || title === "System Quotation ID") {
      return [
        { label: "Edit", value: "edit" },
        { label: "Duplicate", value: "duplicate" },
        { label: "Cancel", value: "cancel" },
        { label: "Push to Quotation", value: "push_to_quotation" },
      ];
    } else if (sales_status === "pending") {
      return [
        { label: "Edit", value: "edit" },
        { label: "Duplicate", value: "duplicate" },
        { label: "Cancel", value: "cancel" },
        { label: "Pushed to Sale", value: "pushed_to_sale" },
        { label: "Push to Quotation", value: "push_to_quotation" },
      ];
    } else {
      return [
        { label: "Push to Quotation", value: "push_to_quotation" },
        { label: "Duplicate", value: "duplicate" },
        { label: "Cancel", value: "cancel" },
      ];
    }
  };

  const sale_status = contractData?.sale_status;
  const sales_status = contractData?.sales_status;
  const title = contractData?.title;
  const dropdownOptions = getDropdownOptions(sale_status, title, sales_status);

  // add remark
  const handleFormSubmit = async (updatedRemark) => {
    const payload = {
      service_id: serviceData?.id,
      remark: updatedRemark,
    };

    try {
      await dispatch(createRemark(payload));
      setRemark(updatedRemark);
      setIsModalOpen(false);
      dispatch(getServiceById(serviceData?.id));
    } catch (error) {
      console.error("Error submitting form: ", error);
    }
  };

  const handleViewReport = async (saleId, type) => {
    try {
      const res = await dispatch(
        createServiceByReport({ id: saleId, type: type })
      );
      if (res?.payload?.download_url) {
        window.open(res?.payload?.download_url, "_blank");
      }
    } catch (err) {
      console.error("Error viewing report:", err);
    }
  };

  const handleDownloadReport = async (saleId, type) => {
    try {
      const res = await dispatch(
        createServiceByReport({ id: saleId, type: type })
      );

      const fileUrl = res?.payload?.download_url;

      if (fileUrl) {
        const response = await fetch(fileUrl);

        if (!response.ok) {
          throw new Error("Network response was not ok.");
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        const fileName = fileUrl.split("/").pop() || "document.pdf";

        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        console.error("Download URL not found");
      }
    } catch (err) {
      console.error("Error downloading report:", err);
    }
  };

  return (
    <>
      {loading ? (
        <RippleLoader />
      ) : (
        <div>
          <div>
            <h6 className="font-Montserrat font-medium text-xl mb-3">
              Service Request
            </h6>
            <Breadcrumb
              breadCrumbParent={"Home"}
              breadCrumbParent2={"Service Request"}
              breadCrumbActive={contractData?.company?.name}
              breadCrumbTitleKey={"/"}
              classes=""
            />
          </div>
          <div className="pt-3 flex justify-between items-center">
            <p className="text-2xl font-Montserrat font-normal">
              {contractData?.company?.name} |{" "}
              {contractData?.service_requests[0]?.service_request_type?.name
                ? contractData.service_requests[0].service_request_type.name
                    .charAt(0)
                    .toUpperCase() +
                  contractData.service_requests[0].service_request_type.name.slice(
                    1
                  )
                : "-"}
            </p>
            <DropdownAction
              value="Action"
              options={dropdownOptions}
              onClick={(option) =>
                handleAddButtonClick(option, contractData?.id)
              }
            />
          </div>

          {/* requeswt info div */}
          <div className="w-full mb-3 mt-3">
            <div className="bg-white p-6 rounded-lg shadow-md w-full shadow-borderDot  border border-borderDot">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-xl font-medium font-Montserrat text-mgrey">
                    Request Information:
                  </h2>
                  <p className="text-themeBtn text-base font-normal font-Proxima">
                    Total Servicing Count: {contractData?.totalServices}
                  </p>
                  <p className="text-themeBtn text-base font-normal font-Proxima">
                    Total Servicing Count Left:{" "}
                    {contractData?.totalServicesCountLeft}
                  </p>
                  <div>
                    {contractData?.technicians?.map((technician, index) => (
                      <p
                        key={index}
                        className="text-mgrey text-base font-normal font-Proxima"
                      >
                        {technician?.user?.full_name || "-"}
                      </p>
                    ))}
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-textSecondary text-sm text-left font-normal font-Proxima">
                    Year: {moment(contractData?.updated_at).format("YYYY")}
                  </p>
                  <p className="text-textSecondary text-sm text-left font-normal font-Proxima">
                    Created On:{" "}
                    {contractData?.updated_at
                      ? moment(contractData?.updated_at).format(
                          "DD/MM/YYYY HH:mm a"
                        )
                      : "No date available"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* info second div */}
          <div className="flex gap-3">
            {/* left side */}
            <div className="w-[70%]">
              {/* first */}
              <div className="bg-bgGrey p-6 rounded-lg shadow-md mb-6  border border-borderDot">
                <div className="flex justify-between items-center pb-4 mb-4 border-b border-b-mGray">
                  <div className="flex items-center">
                    <Badge
                      className={`${
                        contractData?.sales_status === "pending"
                          ? "border-gray-400 text-gray-400"
                          : "border-borderGreen text-bgGreen"
                      }`}
                      value={
                        contractData?.sales_status === "pushed to sales"
                          ? "Pushed to sales"
                          : contractData?.sales_status === "pending"
                          ? "Pending"
                          : "-"
                      }
                    />

                    <h2 className="ml-4 text-sm font-normal text-mgrey font-Proxima">
                      "{contractData?.title}" #{contractData?.unique_id}
                    </h2>
                  </div>
                  <div className="text-sm font-normal flex items-center gap-1 text-mgrey font-Proxima">
                    {contractData?.sale_date_Time}
                    <button
                      onClick={() => setIsQuotationOpen(!isQuotationOpen)}
                    >
                      <DownArrow
                        className={`transform transition-transform duration-300 ${
                          isQuotationOpen ? "rotate-180" : "rotate-0"
                        }`}
                      />
                    </button>
                  </div>
                </div>
                {isQuotationOpen && (
                  <div>
                    {contractData?.service_requests?.map(
                      (serviceRequest, index) => (
                        <div
                          key={index}
                          className="flex justify-between w-full"
                        >
                          <div className="flex w-2/3">
                            <div className="text-base font-normal text-mgrey font-Proxima w-2/3">
                              <p className="text-sm font-normal text-mgrey font-Proxima mt-2">
                                Types:
                              </p>
                              {serviceRequest?.service_request_type?.name ||
                                "-"}
                            </div>
                            <div className="text-base font-normal text-mgrey font-Proxima w-1/3">
                              <p className="text-sm font-normal text-mgrey font-Proxima mt-2">
                                Items:
                              </p>
                              {serviceRequest?.service_request_items?.length > 0
                                ? serviceRequest.service_request_items.map(
                                    (items, idx1) =>
                                      items?.service_request_item_details?.map(
                                        (item, idx2) =>
                                          item?.products?.map((el, idx3) => (
                                            <div
                                              key={`${idx1}-${idx2}-${idx3}`}
                                            >
                                              <p className="text-base font-normal text-mgrey font-Proxima">
                                                {el?.name || "-"}
                                              </p>
                                            </div>
                                          ))
                                      )
                                  )
                                : "-"}
                            </div>
                          </div>

                          <div className="flex w-1/3">
                            <div className="w-4/6">
                              <p className="text-sm font-normal text-mgrey font-Proxima mt-2">
                                Price:
                              </p>
                              {serviceRequest?.service_request_items?.length > 0
                                ? serviceRequest.service_request_items.map(
                                    (items, idx1) =>
                                      items?.service_request_item_details?.map(
                                        (item, idx2) =>
                                          item?.products?.map((el, idx3) => (
                                            <div
                                              key={`${idx1}-${idx2}-${idx3}`}
                                            >
                                              <p className="text-base font-normal text-mgrey font-Proxima">
                                                ${item?.price || 0} x{" "}
                                                {item?.quantity || 0}
                                              </p>
                                            </div>
                                          ))
                                      )
                                  )
                                : "-"}
                            </div>
                            <div className="w-3/12">
                              <p className="text-sm font-normal text-mgrey font-Proxima mt-2">
                                Total:
                              </p>
                              {serviceRequest?.service_request_items?.length > 0
                                ? serviceRequest.service_request_items.map(
                                    (items, idx1) =>
                                      items?.service_request_item_details?.map(
                                        (item, idx2) =>
                                          item?.products?.map((el, idx3) => (
                                            <div
                                              key={`${idx1}-${idx2}-${idx3}`}
                                            >
                                              <p className="text-base font-normal text-mgrey font-Proxima">
                                                $
                                                {item?.price * item?.quantity ||
                                                  0}
                                              </p>
                                            </div>
                                          ))
                                      )
                                  )
                                : "-"}
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
              </div>
              {/* second */}
              <div className="bg-white p-6 rounded-lg shadow-md mb-6  border border-borderDot">
                <div className="flex justify-between items-center pb-4 mb-4 border-b border-b-mGray">
                  <div className="flex items-center">
                    <Badge
                      className={`${
                        contractData?.payment_status === "unpaid"
                          ? "bg-red"
                          : "bg-bgGreen"
                      } text-white`}
                      value={
                        contractData?.payment_status === "unpaid"
                          ? "Unpaid"
                          : "-"
                      }
                    />
                    <h2 className="ml-4 text-sm font-normal text-mgrey font-Proxima">
                      {contractData?.subtitle}
                    </h2>
                  </div>
                  <div className="flex items-center gap-1">
                    <p className="text-sm font-normal text-mgrey font-Proxima">
                      {" "}
                      {contractData?.payment_date_time}
                    </p>
                    <button onClick={() => setIsReceiptOpen(!isReceiptOpen)}>
                      <DownArrow
                        className={`transform transition-transform duration-300 ${
                          isReceiptOpen ? "rotate-180" : "rotate-0"
                        }`}
                      />
                    </button>
                  </div>
                </div>
                {isReceiptOpen && (
                  <div>
                    <div className="mb-4 pb-4 border-b border-b-mGray">
                      <div className="flex justify-between items-center">
                        <div className="text-sm font-normal text-mgrey font-Proxima">
                          Subtotal:
                        </div>
                        <div className="text-sm font-normal text-mgrey font-Proxima">
                          ${contractData?.subTotal}
                        </div>
                      </div>
                      <div className="flex justify-between items-center">
                        <div className="text-sm font-normal text-mgrey font-Proxima">
                          GST {contractData?.gstPrice}%:
                        </div>
                        <div className="text-sm font-normal text-mgrey font-Proxima">
                          ${contractData?.gst}
                        </div>
                      </div>
                      <div className="flex justify-between items-center">
                        <div className="text-sm font-normal text-mgrey font-Proxima">
                          Total:
                        </div>
                        <div className="text-sm font-normal text-mgrey font-Proxima">
                          $
                          {contractData?.total
                            ? Number(contractData.total).toFixed(2)
                            : "0.00"}
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-between items-center bg-bgLightTheme p-4 rounded">
                      <div className="text-sm font-normal text-mgrey font-Proxima">
                        {contractData?.payment_status === "unpaid"
                          ? "Total Payable"
                          : "Paid"}
                      </div>
                      <div className="text-sm font-normal text-themeBtn font-Proxima">
                        $
                        {contractData?.total
                          ? Number(contractData.total).toFixed(2)
                          : "0.00"}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {/* third */}
              <div className="bg-bgLightTheme p-6 rounded-lg shadow-md mb-6  border border-borderDot">
                <div className="flex justify-between items-center mb-2 border-b border-b-mGray pb-4">
                  <div className="flex items-center gap-2 ">
                    <Clock />
                    <h2 className="text-sm font-normal text-mgrey font-Proxima">
                      Time Stamp ({contractData?.service_time_stamp_log?.length}
                      )
                    </h2>
                  </div>
                  <button onClick={() => setIsTimestampOpen(!isTimestampOpen)}>
                    <DownArrow
                      className={`transform transition-transform duration-300 ${
                        isTimestampOpen ? "rotate-180" : "rotate-0"
                      }`}
                    />
                  </button>
                </div>
                {isTimestampOpen && (
                  <div>
                    {contractData?.service_time_stamp_log.map(
                      (timestamp, index) => (
                        <div
                          key={index}
                          className="p-4 rounded-lg flex justify-between hover:bg-hoverTheme relative"
                        >
                          <div className="flex flex-col font-Proxima relative w-full">
                            <div className="text-sm font-normal text-mgrey flex">
                              <p>{timestamp?.outlet}</p>
                            </div>
                            <div className="text-sm font-normal text-mgrey flex">
                              <p>{timestamp?.title}</p>
                            </div>
                            <div className="relative flex items-center w-full">
                              <div className="absolute -left-5 -top-1 transform -translate-x-1/2 w-3 h-3 bg-stepGray rounded-full" />
                            </div>
                            <div
                              className={`${
                                index !== 0
                                  ? "h-full border border-stepGray absolute -left-5 -top-11"
                                  : ""
                              }`}
                            />
                            <p className="text-sm text-mgrey">
                              {timestamp?.subtitle}
                            </p>
                          </div>

                          <div className="flex items-center gap-4 font-Proxima">
                            <div className="text-sm text-mgrey font-normal mt-2">
                              <p>{timestamp?.date_Time}</p>
                            </div>
                            {timestamp?.report_available === true ? (
                              <Action
                                optionList={
                                  <>
                                    <li
                                      className="text-base font-normal text-mgrey px-4 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer "
                                      onClick={() => {
                                        handleViewReport(
                                          timestamp?.sales_id,
                                          timestamp?.type
                                        );
                                      }}
                                    >
                                      View
                                    </li>
                                    <li
                                      className="text-base font-normal text-mgrey px-4 py-2 bg-white hover:bg-hoverTheme transition duration-300 
                                cursor-pointer"
                                      onClick={() => {
                                        handleDownloadReport(
                                          timestamp?.sales_id,
                                          timestamp?.type
                                        );
                                      }}
                                    >
                                      Download
                                    </li>
                                  </>
                                }
                              />
                            ) : (
                              <div className="px-4 py-2 " />
                            )}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* right side */}
            <div className="w-[30%]">
              {/* remark */}
              <div className="bg-white p-6 rounded-lg shadow-md mb-6 w-full  border border-borderDot">
                <div className="flex items-center justify-between pb-4 mb-4 border-b border-b-mGray">
                  <p className="text-sm font-normal text-mgrey font-Proxima">
                    Remark
                  </p>
                  {contractData?.remarks ? (
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        setIsEditing(true);
                        setRemark(contractData.remarks);
                        setIsModalOpen(true);
                      }}
                    >
                      <Edit />
                    </div>
                  ) : (
                    <button
                      onClick={() => {
                        setIsEditing(false);
                        setRemark("");
                        setIsModalOpen(true);
                      }}
                      className="text-themeBtn text-sm font-medium underline cursor-pointer font-Proxima"
                    >
                      Add
                    </button>
                  )}
                </div>
                {contractData?.remarks ? (
                  <div className="bg-bgblue p-3 rounded-lg">
                    <p className="font-normal text-sm text-textSecondary font-Proxima min-w-[150px] max-w-[300px] truncate">
                      {contractData?.remarks}
                    </p>
                  </div>
                ) : (
                  <div className="bg-bgblue p-3 rounded-lg">
                    <p className="text-sm font-normal text-mgrey font-Proxima">
                      No Remark Available
                    </p>
                  </div>
                )}
              </div>

              {/* outlet */}
              <div className="max-w-sm mx-auto my-4 p-4 bg-white shadow-lg rounded-lg  border border-borderDot">
                <div className="mb-4 border-b border-b-mGray pb-4 flex justify-between items-center">
                  <h2 className="text-sm font-normal text-mgrey font-Proxima">
                    Outlets ({contractData?.companyOutlets?.length})
                  </h2>
                  <button onClick={() => setIsListVisible(!isListVisible)}>
                    <DownArrow
                      className={`transform transition-transform duration-300 ${
                        isListVisible ? "rotate-180" : "rotate-0"
                      }`}
                    />
                  </button>
                </div>

                {isListVisible && (
                  <div className="space-y-2">
                    {contractData?.companyOutlets?.map((outlet, index) => (
                      <div
                        key={index}
                        className="p-4 rounded-lg bg-lightWarning2 hover:bg-lightwarning"
                      >
                        <div className="flex justify-between">
                          <div className="flex gap-2 items-start">
                            <span className="font-normal text-sm text-mgrey font-Proxima pt-1">
                              {index + 1}
                            </span>
                            <div className="mt-1 ml-2">
                              <p className="font-normal text-sm text-mgrey font-Proxima">
                                {outlet?.name}
                              </p>
                              <p className="font-normal text-xs text-mgrey font-Proxima">
                                {outlet?.address}
                              </p>
                              <p className="font-normal text-xs text-mgrey font-Proxima">
                                {outlet?.postal_code}
                              </p>
                            </div>
                          </div>
                          <div className="text-xs text-textSecondary text-left font-Proxima mt-1 w-1/4">
                            <p>Last Service:</p>
                            <p>
                              {" "}
                              {outlet?.last_service_date_time
                                ? outlet?.last_service_date_time
                                : "-"}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isModalOpen && (
        <EditRemarkModal
          onClose={() => setIsModalOpen(false)}
          onConfirm={(updatedRemark) => {
            setRemark(updatedRemark);
            handleFormSubmit(updatedRemark);
          }}
          remarkText={remark}
          confirmText={isEditing ? "Edit" : "Add"}
        />
      )}
      {isExistingModalOpen && (
        <ExistingQuotationModal
          onClose={() => setIsExistingModalOpen(false)}
          existingData={existingData}
        />
      )}
    </>
  );
};

export default ViewService;
